import React, { Component } from "react";
import CustomButton from "./CustomComponents/CustomButton";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, navigate: props.navigate };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true });
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <React.Fragment>
          <div
            style={{
              textAlign: "center",
              marginTop: window.innerHeight / 4,
              position: "relative",
              color: "red",
              overflow: "hidden",
            }}
          >
            Something went Wrong try After Sometime.
          </div>
          <div
            style={{
              textAlign: "center",
              position: "relative",
            }}
          >
            <CustomButton
              sx={{ height: "2rem", marginTop: "64px" }}
              variant="contained"
              onClick={() => {
                this.state.navigate("/stlap/home/dashboard", { replace: true });
                this.state.hasError = false;
              }}
            >
              Back to Dashboard
            </CustomButton>
          </div>
        </React.Fragment>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
